import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

const BulkAction = ({
  number,
  buttonClassname,
  buttonText,
  handleClick,
  buttonDisabled = false,
}) => {
  return (
    <div className="bulk-action">
      <div className="bulk-action__number">{number}</div>
      <button
        className={cn(['btn', 'bulk-action__btn'], buttonClassname)}
        disabled={buttonDisabled}
        onClick={handleClick}
      >
        {buttonText}
      </button>
    </div>
  )
}

BulkAction.propTypes = {
  number: PropTypes.string,
  buttonClassname: PropTypes.string,
  buttonText: PropTypes.string,
  handleClick: PropTypes.func,
  buttonDisabled: PropTypes.bool,
}

export default BulkAction
